import style from './style.module.css'

const SuperUserHeader = ({ superModalPath, setSuperModalPath }) => {
  const handleClick = (e) => {
    const path = e.target.getAttribute('name')

    setSuperModalPath(path)
  }

  return (
    <div className={style.superUserHeader}>
      <ul className={style.superUserHeader_list}>
        <li
          className={style.superUserHeader_item}
          name="CREATE_ENTERPRISE"
          onClick={handleClick}
        >
          Create Enterprise
        </li>
      </ul>
    </div>
  )
}

export default SuperUserHeader
